import fetchHandler from "../../utils/fetchHandler";
import { AD_MANAGEMENT } from "../types/actions";

export const getAdsList = () => {
	const fetchOptions = {
		url: `/api/ads`,
		method: "GET",
		actionType: AD_MANAGEMENT.GET_ADS_LIST
	};
	return fetchHandler(fetchOptions);
};

export const addNewAd = (values, fileType, successHandler, errorHandler) => {
	let fetchOptions;
	if (fileType === "video") {
		fetchOptions = {
			url: `/api/ads`,
			method: "POST",
			actionType: AD_MANAGEMENT.ADD_NEW_AD_SUCCESS,
			body: JSON.stringify(values)
		};
	} else if (fileType === "image") {
		fetchOptions = {
			url: `/api/ads`,
			method: "POST",
			actionType: AD_MANAGEMENT.ADD_NEW_AD_SUCCESS,
			body: values,
			isFileUpload: true
		};
	}
	return fetchHandler(fetchOptions, successHandler, errorHandler);
};

export const updateAd = (values, adId, successHandler, errorHandler) => {
	const fetchOptions = {
		url: `/api/ads/${adId}`,
		method: "PUT",
		actionType: AD_MANAGEMENT.UPDATE_AD_SUCCESS,
		body: JSON.stringify(values)
	};
	return fetchHandler(fetchOptions, successHandler, errorHandler);
};

export const deleteAd = (deleteItem, successHandler) => {
	const fetchOptions = {
		url: `/api/ads/${deleteItem.id}`,
		method: "DELETE",
		actionType: AD_MANAGEMENT.DELETE_AD_SUCCESS
	};
	return fetchHandler(fetchOptions, successHandler);
};
